<div class="toast-wrapper" [@toastAppearance]>
  <ng-content></ng-content>
</div>
